import React from "react";
import { Typography, Divider, Grid } from "@mui/material";
import { motion } from "framer-motion";
import Weather from "../../../../components/common/Weather";
import type { IExpandedCallSheetData } from "../../../../types/callsheet";
import type { CallSheetData } from "./types/callsheet";

interface CallSheetScheduleProps {
  callSheetData: IExpandedCallSheetData;
  timeData: CallSheetData | null;
  reduxTheme: unknown;
}

const CallSheetSchedule: React.FC<CallSheetScheduleProps> = ({
  callSheetData,
  timeData,
  reduxTheme: _reduxTheme,
}) => {
  void _reduxTheme;
  return (
    <motion.div
      initial={{ x: 20, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ delay: 0.5 }}
    >
      <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold" }}>
        {callSheetData?.date &&
          new Date(callSheetData.date).toLocaleDateString("en-GB", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
      </Typography>
      <Divider sx={{ my: 2 }} />
      <Weather service_id={callSheetData?.booking?.services?.[0]?.id} />
      <Divider sx={{ my: 2 }} />

      {/* Schedule Grid */}
      <Grid container spacing={1}>
        {[
          {
            label: "Call Time:",
            value: `${timeData?.call_time?.substring(
              0,
              5
            )} - ${timeData?.departure_time?.substring(0, 5)}`,
          },
          {
            label: "Travelling:",
            value: `${timeData?.arrival_at_venue_time?.substring(
              0,
              5
            )} - ${timeData?.setup_from_time?.substring(0, 5)}`,
          },
          {
            label: "Setup:",
            value: `${timeData?.setup_from_time?.substring(
              0,
              5
            )} - ${timeData?.setup_to_time?.substring(0, 5)}`,
          },
          {
            label: "Shoot:",
            value: `${timeData?.shoot_start_time?.substring(
              0,
              5
            )} - ${timeData?.shoot_end_time?.substring(0, 5)}`,
          },
          {
            label: "Wrap:",
            value: `${timeData?.estimated_wrap_time?.substring(
              0,
              5
            )} - ${timeData?.back_to_base_time?.substring(0, 5)}`,
          },
        ].map((item) => (
          <React.Fragment key={item.label}>
            <Grid size={{ xs: 6 }}>
              <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
                {item.label}
              </Typography>
            </Grid>
            <Grid size={{ xs: 6 }}>
              <Typography variant="body2">{item.value}</Typography>
            </Grid>
          </React.Fragment>
        ))}
      </Grid>
    </motion.div>
  );
};

export default CallSheetSchedule;
